import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TraysService } from 'src/app/api/services/trays.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-tray-detail',
  templateUrl: './tray-detail.component.html',
  styleUrls: ['./tray-detail.component.scss']
})
export class TrayDetailComponent {

  protected loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TrayDetailComponent>,
    public sharedService: SharedService,
    public traysService: TraysService,
    public translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  closeDialog(edited?: boolean) {
    this.dialogRef.close(edited);
  }

  cancel() {
    this.closeDialog()
  }

  handleClose(event: any) {
    this.closeDialog(event);
  }

}
